module.exports = __webpack_public_path__ + "assets/img/news (1).e908a943.png";